// @flow

import React, { type Node } from 'react';
import styled from 'styled-components';
import {
  getSafeGatewayUssdCode,
  usePendingIncomingPayment,
} from '@tectonics/prs/incoming-payment';
import ussdIconSrc from './icons/ussd-icon.svg';

export function UssdPageContent(): Node {
  const incomingPayment = usePendingIncomingPayment();
  const ussdCode = getSafeGatewayUssdCode(incomingPayment);

  return(
    <Root data-test-id="page-pending-payment">
      <Body>
        Dial the <b>USSD code</b> below on your mobile phone to complete the payment
        <IconWrapper>
          <Icon src={ussdIconSrc} alt="ussd" />
          <IconLabel>{ussdCode}</IconLabel>
        </IconWrapper>
      </Body>
    </Root>
  );
}

const Root = styled.div`
  color: ${props => props.theme.colors.gray[20]};
`;

const Body = styled.div`
  padding: 32px 16px;
  font-size: 1.8em;
  font-family: ${props => props.theme.fontFamily.display};
`;

const IconWrapper = styled.div`
  display: flex;
  flex-grow: 1;
  align-items: center;
  justify-content:
  center;
  margin-top: 30px;
`;

const Icon = styled.img`
  height: 35px;
  width: auto;
`;

const IconLabel = styled.div`
  font-weight: bold;
  font-size: 16px;
  margin-left: 10px;
`;
